import { render, staticRenderFns } from "./EditorUnsaveDialog.vue?vue&type=template&id=25f37cfa&"
import script from "./EditorUnsaveDialog.vue?vue&type=script&lang=js&"
export * from "./EditorUnsaveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports